import { FormControl, FormGroup } from '@angular/forms';
import { CommonField } from '../models/Field';

// `FieldBase[]` -> `FormGroup`
export function customFieldsToFormGroup(fields: CommonField[]): FormGroup {
  let controls: Record<string, FormControl> = {};

  fields.forEach((field) => {
    const validators = Object.keys(field.rules).map((rKey) => field.rules[rKey].validator);
    controls[field.key] = field.isLocked
      ? new FormControl({ value: field.value, disabled: true }, validators)
      : new FormControl(field.value, validators);
  });

  return new FormGroup(controls);
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/utilities/customFieldsToFormGroup.ts